/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import * as styles from './Table.scss'

const cx = classNames.bind(styles)

interface IProps {
  columns: any[],
  data: any[],
  t: Text,
}

const renderCellContent = (rowItem, cellItem) => {
  return cellItem.cellContentRender ?
    cellItem.cellContentRender(rowItem[cellItem.dataKey], rowItem) : rowItem[cellItem.dataKey]
}

const renderBody = (columns, data, t) => {
  if (!data.length) {
    return (
      <tr>
        <td className={styles.noData} colSpan={columns.length}>{t('noData')}</td>
      </tr>
    )
  }
  return data.map((rowItem, i) => (
    <tr key={i}>
      {columns.map((cellItem, n) => {
        return <td key={n}>{renderCellContent(rowItem, cellItem)}</td>
      })}
    </tr>
  ))
}

const Table: React.SFC<IProps> = ({ columns, data, t }) => (
  <table className={cx('table', 'table-sm', styles.tableRoot)}>
    <thead>
      <tr>
        {Object.keys(columns).map((key, i) => (
          <th style={{ width: columns[key].width }} key={i} scope='col'>{columns[key].title}</th>
        ))}
      </tr>
    </thead>
    <tbody>
     {renderBody(columns, data, t)}
    </tbody>
  </table>
)

export default Table
